
/* injects from baggage-loader */

'use strict';

// import _ from 'lodash';

export default class FableDialogController {
	constructor($log, $state, $timeout) {
		'ngInject';
		this.$log = $log;
		this.$state = $state;
		this.$timeout = $timeout;
	}    

	$onInit(){
		this.wordsFable = {
			drag: ['perto', 'longe', 's', 'z'],
			textDrop: "O galo e as galinhas viram que<br/> lá <span class='word-drop' ui-on-drop='$ctrl.onDropShape($data, $event)'></span> vinha uma rapo<span class='letter-drop' ui-on-drop='$ctrl.onDropShape($data, $event)'></span>a."
		}
	}

	onDropShape(data, el){
		this.$log.log("elemento dropado:");
		this.$log.log(data);
		this.$log.log("recipiente:");
		this.$log.log(el);
	}
}


// WEBPACK FOOTER //
// ./src/app/components/ui/fable-dialog/fable-dialog.controller.js